const ranking = [
  { rank: 1, title: '星际迷航：新纪元', type: '科幻 / 冒险', hot: '🔥 12.8万', change: 'up' },
  { rank: 2, title: '风暴追击', type: '动作 / 犯罪', hot: '🔥 10.5万', change: 'up' },
  { rank: 3, title: '霸王别姬（数字重制版）', type: '剧情 / 历史', hot: '🔥 9.3万', change: 'new' },
  { rank: 4, title: '喜剧之王2', type: '喜剧 / 剧情', hot: '8.7万', change: 'down' },
  { rank: 5, title: '暗夜追踪', type: '悬疑 / 惊悚', hot: '7.2万', change: 'up' },
  { rank: 6, title: '流浪苍穹', type: '科幻 / 灾难', hot: '6.8万', change: 'same' },
  { rank: 7, title: '功夫世家', type: '动作 / 喜剧', hot: '6.1万', change: 'down' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1024px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-300 bg-accent-500/10 rounded-full mb-4">
            热度榜单
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-50 mb-3">
            热度榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-400 max-w-[560px] mx-auto">
            实时更新的观影热度排行，看看本周大家都在看什么
          </p>
        </div>

        <div className="rounded-xl bg-background-200/70 border border-background-300/40 overflow-hidden">
          <div className="hidden md:grid grid-cols-12 gap-4 px-6 py-3 border-b border-background-300/40 text-xs font-medium text-foreground-500">
            <div className="col-span-1">排名</div>
            <div className="col-span-5">影片</div>
            <div className="col-span-2">类型</div>
            <div className="col-span-2">热度</div>
            <div className="col-span-2">趋势</div>
          </div>

          {ranking.map((item, idx) => (
            <div
              key={idx}
              className={`group grid grid-cols-1 md:grid-cols-12 gap-3 md:gap-4 px-4 md:px-6 py-4 items-center cursor-pointer transition-all duration-200 hover:bg-background-300/30 ${
                idx < ranking.length - 1 ? 'border-b border-background-300/30' : ''
              }`}
            >
              <div className="md:col-span-1 flex items-center gap-3 md:gap-0">
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm ${
                    item.rank === 1
                      ? 'bg-accent-500 text-background-50'
                      : item.rank === 2
                      ? 'bg-accent-500/70 text-background-50'
                      : item.rank === 3
                      ? 'bg-accent-500/40 text-accent-200'
                      : 'bg-background-300/40 text-foreground-500'
                  }`}
                >
                  {item.rank}
                </div>
                <span className="md:hidden text-sm font-semibold text-foreground-200">{item.title}</span>
              </div>
              <div className="md:col-span-5 hidden md:block">
                <span className="text-sm font-semibold text-foreground-200 group-hover:text-foreground-100 transition-colors">
                  {item.title}
                </span>
              </div>
              <div className="md:col-span-2 ml-11 md:ml-0">
                <span className="text-xs text-foreground-500 bg-background-300/40 px-2 py-0.5 rounded">
                  {item.type}
                </span>
              </div>
              <div className="md:col-span-2 ml-11 md:ml-0">
                <span className="text-xs font-medium text-primary-400">{item.hot}</span>
              </div>
              <div className="md:col-span-2 ml-11 md:ml-0">
                <span className="text-xs">
                  {item.change === 'up' && <i className="ri-arrow-up-line text-accent-400"></i>}
                  {item.change === 'down' && <i className="ri-arrow-down-line text-foreground-600"></i>}
                  {item.change === 'new' && <span className="text-accent-400 font-medium">NEW</span>}
                  {item.change === 'same' && <i className="ri-subtract-line text-foreground-600"></i>}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}